import { Box, Paper, styled } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

export const StepItemWrapper = styled(Paper, {
	shouldForwardProp: (prop) => prop !== 'mainColor',
})<{ mainColor?: string }>(({ mainColor }) => ({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	border: '1px solid',
	borderColor: mainColor,
	borderRadius: '8px',
	maxHeight: '250px',

	padding: '8px',
}));

export const StyledStepNumber = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'mainColor',
})<{ mainColor?: string }>(({ mainColor }) => ({
	position: 'absolute',

	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	color: '#fff',
	backgroundColor: mainColor,

	top: '-12px',
	left: '-4px',
	width: '37px',
	height: '40px',
	clipPath:
		'path("M14.3496 1.9238C16.9202 0.449526 20.0798 0.449524 22.6504 1.9238L32.1017 7.34442C34.6945 8.83145 36.2936 11.592 36.2936 14.5809L36.2936 25.3265C36.2936 28.3154 34.6945 31.076 32.1017 32.563L22.6504 37.9836C20.0798 39.4579 16.9202 39.4579 14.3496 37.9836L4.8983 32.563C2.30551 31.076 0.706427 28.3154 0.706426 25.3265L0.706427 14.5809C0.706427 11.592 2.30551 8.83146 4.89829 7.34442L14.3496 1.9238Z")',
}));

export const StyledImage = styled('img')(() => ({
	width: '100%',
	borderRadius: '6px',
	height: '100%',
	objectFit: 'contain',
}));

export const StyledMediaTypography = styled(MediaTypography)(() => ({
	textIndent: '25px',
	textAlign: 'right',
}));
